<template>
  <div>
    <div class="">
      <Speaker submission_id="0" area="home" textkey="modal_invoice_process"/>
    </div>
    <div v-if="!processing">
      <div class="mt-3" v-if="invoiceUrl !== null">
        <a :href="invoiceUrl" target="_blank" class="btn btn-success">
          <icon :icon="['fad', 'receipt']" class=""/>&nbsp;<Speaker submission_id="0" area="home" textkey="modal_invoice_button"/>
        </a><br>
        <Speaker submission_id="0" area="home" textkey="modal_invoice_downloadnote"/>
      </div>
      <div class="alert alert-danger mt-3" v-else>
        <Speaker submission_id="0" area="home" textkey="modal_invoice_noinvoice"/>
      </div>
    </div>
    <div v-else>
      <Loader></Loader>
    </div>
  </div>
</template>

<script>
import {mapActions, mapState} from 'vuex'

export default {
  props: ['abstract_id'],
  name: "payment_invoice",
  created() {

  },
  mounted() {
    this.getInvoice();
  },
  data() {
    return {
      invoiceUrl: null,
      processing: false,
    }
  },
  computed: {
    ...mapState([
      'abstract'
    ]),
  },
  methods: {
    ...mapActions('payment', ['GET_INVOICE']),
    async getInvoice() {
      this.processing = true;
      await this.GET_INVOICE(this.abstract_id).then((result) => {
        this.invoiceUrl = result.data;
        this.processing = false;
      }).catch((error) => {
        this.invoiceUrl = null;
        this.processing = false;
      });
    }
  }
}
</script>

<style scoped>

</style>
